
























































































































import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { getQiniuToken } from "@/api/admin";
import {
  Schedule,
  createSchedule,
  getSchedule,
} from "@/api/schedule";
import * as uuid from "uuid";
import { Meter, ResCode } from "@/api/baseDefine";
@Component
export default class UploadScheduleDialog extends Vue {
  private uploadQiniuUrl: string = "https://up-z2.qiniup.com"; // 七牛云服务器地址
  private dialogVisible: boolean = false;
  private meters:Meter[] = []
  private editSchedule1:Schedule = <Schedule>{}
  private editSchedule2:Schedule = <Schedule>{}
  private fileList = [];
  private fileUrl = "";
  private qiniuData = {
    key: "", // 图片名字处理
    token: "", // 七牛云token
    domain: "",
  };
  private clickShow(meters: Meter[]) {
    this.dialogVisible = true;
    this.meters = meters
    console.log(meters)
    console.log("xxxxxxxxxxxx",this.meters[0])
    this.editSchedule1.meterID = this.meters[0].meterID
    this.editSchedule1.powerPlantId = this.meters[0].powerPlantId
    this.editSchedule1.type = "stable"
    this.editSchedule1.name = ""
    this.editSchedule1.interval=0
    this.editSchedule2.meterID = this.meters[0].meterID
    this.editSchedule2.powerPlantId = this.meters[0].powerPlantId
    this.editSchedule2.type = "updated"
    this.editSchedule2.name = ""
    // this.editSchedule2.interval=0
    // console.log("xxxxxxxxxxxx",this.meters[0])
    this.getSchedule()
  }

  private async getSchedule(){
    // const res = await getSchedule(this.editSchedule)
    // if (!!res && !!res.data) {
    //     this.editSchedule = res.data
    // }
    // console.log(this.editSchedule)
  }

  private async createSchedule1() {
    let meter = this.meters[0]
    const res = await createSchedule(this.editSchedule1);
    if (!!res && res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.UploadSuccess").toString(),
        type: "success",
      });
      this.dialogVisible = false
    }
  }

    private async createSchedule2() {
    let meter = this.meters[0]
    if(!this.editSchedule2.interval){
        this.editSchedule2.interval = 5 
    }
    const res = await createSchedule(this.editSchedule2);
    if (!!res && res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.UploadSuccess").toString(),
        type: "success",
      });
      this.dialogVisible = false
    }
  }

  private beforeUploadGetKey(f1, f2) {
    this.qiniuData.key = "meter/schedule/" + uuid.v1();
  }

  private successUploadGetKey1(response, file, fileList) {
    this.fileUrl = this.qiniuData.domain + "/" + this.qiniuData.key;
    this.$notify({
      title: this.$t("common.success").toString(),
      message: this.$t("notification.UploadSuccess").toString(),
      type: "success",
      duration: 2000,
    });
    this.editSchedule1.file = this.fileUrl;
  }

  private successUploadGetKey2(response, file, fileList) {
    this.fileUrl = this.qiniuData.domain + "/" + this.qiniuData.key;
    this.$notify({
      title: this.$t("common.success").toString(),
      message: this.$t("notification.UploadSuccess").toString(),
      type: "success",
      duration: 2000,
    });
    this.editSchedule2.file = this.fileUrl;
  }

  public async qiniuToken() {
    const res = await getQiniuToken();
    if (res && res.code === ResCode.SUCCESS) {
      this.qiniuData.token = res.data.token;
      this.qiniuData.domain = res.data.domain;
    }
    console.log(this.qiniuData)
  }
  private async created() {
        this.qiniuToken();
  }
}


